import { render, staticRenderFns } from "./double_arrow_left.vue?vue&type=template&id=abb42aac"
import script from "./double_arrow_left.vue?vue&type=script&lang=js"
export * from "./double_arrow_left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports